<template>
  <v-card :title="t('generals')">
    <v-form @submit.prevent="submit">
      <v-card-text class="pt-0 pb-0">
        <v-row>
          <v-col>
            <v-text-field
              v-model="form.name.value.value"
              :error-messages="form.name.errorMessage.value"
              :label="t('parkName')"
              density="compact"
            />
          </v-col>
          <v-col>
            <v-autocomplete
              class="mb-2"
              :label="t('agency')"
              density="compact"
              clearable
              hide-details
              v-model="form.agency.value.value"
              :error-messages="form.agency.errorMessage.value"
              :items="agencys"
              item-title="visual_name"
              item-value="id"
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="form.amount_to_imprint_cents.value.value"
              :error-messages="form.amount_to_imprint_cents.errorMessage.value"
              :label="t('amountToImprint')"
              density="compact"
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="form.installation_date.value.value"
              :error-messages="form.installation_date.errorMessage.value"
              type="datetime-local"
              :label="t('installationDate')"
              density="compact"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3" class="pe-3 me-3">
            <v-card elevation="4">
              <v-card-title>{{ t('advenirBootstrap') }}</v-card-title>
              <v-card-text>
                <v-text-field
                  :label="t('testTransactionId')"
                  density="compact"
                  hide-details
                  v-model="tId"
                />
              </v-card-text>
              <v-card-actions class="pt-0">
                <v-btn border style="width: 100%" @click="advenirSubmit">{{ t('sendTestData') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="3" class="pe-3 me-3">
            <v-card elevation="4">
              <v-card-text>
                <v-row>
                  <v-col cols="6" class="py-0 px-0 border">
                    <v-checkbox
                      style="height: 100%"
                      v-model="form.installed.value.value"
                      :label="t('installed')"
                      density="compact"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="6" class="py-0 px-0 border">
                    <v-checkbox
                      style="height: 100%"
                      v-model="form.test_mode.value.value"
                      :label="t('test')"
                      density="compact"
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="py-0 px-0 border">
                    <v-checkbox
                      style="height: 100%"
                      v-model="form.accept_gireve.value.value"
                      :label="t('gireve')"
                      density="compact"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="6" class="py-0 px-0 border">
                    <v-checkbox
                      style="height: 100%"
                      v-model="form.coupon_enabled.value.value"
                      :label="t('coupon')"
                      density="compact"
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="py-0 px-0 border">
                    <v-checkbox
                      style="height: 100%"
                      v-model="form.has_pilotage.value.value"
                      :label="t('pilotage')"
                      density="compact"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="6" class="py-0 px-0 border">
                    <v-checkbox
                      style="height: 100%"
                      v-model="form.has_roof.value.value"
                      :label="t('roof')"
                      density="compact"
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="py-0 px-0 border">
                    <v-checkbox
                      style="height: 100%"
                      v-model="form.feature_only_solar.value.value"
                      :label="t('featureOnlySolar')"
                      density="compact"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="6" class="py-0 px-0 border d-flex align-center">
                    <div
                      v-if="contractInfo == null"
                      class="d-flex align-center ga-1 mx-2 text-medium-emphasis"
                    >
                      <v-icon size="x-small">mdi-flash-off</v-icon>
                      {{ t('contractNoInfo') }}
                    </div>
                    <div
                      v-else-if="!contractInfo.enable_tilt"
                      class="d-flex align-center ga-1 mx-2 text-error"
                    >
                      <v-icon size="x-small" color="error">mdi-flash-off</v-icon>
                      {{ t('contractTiltDisabled') }}
                    </div>
                    <v-checkbox
                      v-else
                      v-model="tiltActive"
                      :label="t('tilt')"
                      density="compact"
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-row>
              <v-col class="pt-3">
                <v-textarea
                  v-model="form.note.value.value"
                  :error-messages="form.note.errorMessage.value"
                  :label="t('note')"
                  hide-details
                  rows="4"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0 pb-3">
                <v-text-field
                  density="compact"
                  label="PRM"
                  v-model="form.prm.value.value"
                  :error-messages="form.prm.errorMessage.value"
                />
              </v-col>
              <v-col class="pt-0 pb-3">
                <v-text-field
                  v-model="form.label.value.value"
                  :error-messages="form.label.errorMessage.value"
                  :label="t('parkLabel')"
                  density="compact"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col></v-col>
          <v-col cols="3" class="py-0">
            <v-card-actions class="justify-end">
              <v-btn border type="submit">{{ t('save') }}</v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script setup>
import { ref, toRefs, computed } from "vue";
import { useModifyParkBase } from "./base.js";
import { toLocalDatetime } from "../../utils.js";
import * as yup from 'yup';
import { sendAdvenirTestData } from "../../remote/advenir.js";
import { useI18n } from "vue-i18n";
import { fetchMaintenanceData } from "@/remote/maintenancedata.js";

const { t } = useI18n({ inheritLocale: true, useScope: 'local' });
// General State
const useAlerts = defineModel('useAlerts');
const loadingOverlay = defineModel('loadingOverlay');
const props = defineProps(['originalPark', 'agencys', 'contractInfo']);
const { originalPark, agencys, contractInfo } = toRefs(props);
const emit = defineEmits(['updated']);

// Form
// noinspection JSCheckFunctionSignatures
const schema = yup.object({
  name: yup.string().required().matches(/^[\x20-\x7E]*$/, {
    message: t("parkNameAsciiError"),
    excludeEmptyString: true,
  }),
  label: yup.string().nonNullable(),
  agency: yup.number().integer().nullable(),
  installed: yup.boolean(),
  accept_gireve: yup.boolean(),
  coupon_enabled: yup.boolean(),
  test_mode: yup.boolean(),
  has_pilotage: yup.boolean(),
  has_roof: yup.boolean(),
  feature_only_solar: yup.boolean(),
  force_no_tilt: yup.boolean(),
  amount_to_imprint_cents: yup.number().integer().positive().required(),
  installation_date: yup.date().nullable().transform((value, originalValue) => originalValue === '' ? null : value),
  note: yup.string(),
  prm: yup.string().default("").matches(/^\d{14}$/, { message: t("prm_error"), excludeEmptyString: true }),
});
const skipSetFields = ['installation_date'];
const specialSetter = (form, newValue) => {
  // noinspection JSPrimitiveTypeWrapperUsage
  form.installation_date.value.value = toLocalDatetime(newValue.installation_date);
};
const editPayload = (values) => {
  values.installation_date = values.installation_date === "" ? null : values.installation_date;
};

const { form, submit: base_submit } = useModifyParkBase(
  useAlerts, loadingOverlay, originalPark, schema, emit, skipSetFields, specialSetter, editPayload
);

const tiltActive = computed({
  get: () => !form.force_no_tilt.value.value,
  set: (val) => {
    form.force_no_tilt.value.value = !val;
  }
});

async function submit() {
  if (form.installed.value.value && !originalPark.value.installed) {
    if (form.prm.value.value === '') {
      alert(t('prmEmptyError'));
      return;
    }
    // Example if you want to confirm instead of block totally
    // if (originalPark.value.yearly_report_image === null) {
    //   if (!confirm(t('yearlyReportImageMissingConfirm'))) {
    //     return;
    //   }
    // }
    if (originalPark.value.yearly_report_image === null) {
      alert(t('yearlyReportImageMissingError'));
      return;
    }
    const md = await fetchMaintenanceData(originalPark.value.id);
    if (md === null) {
      alert(t('maintenanceDataMissingError'));
      return;
    }
  }
  base_submit();
}

// ADVENIR
const tId = ref(null);

async function advenirSubmit() {
  const transId = tId.value === '' ? null : tId.value;
  loadingOverlay.value = true;
  try {
    await sendAdvenirTestData(useAlerts, originalPark.value.id, transId);
  } catch (e) {
    useAlerts.value.errorAlert(t('errorAdvenirTestData'), e.toString());
  } finally {
    loadingOverlay.value = false;
  }
}
</script>

<i18n>
{
  "en": {
    "generals": "Generals",
    "parkName": "Park Name",
    "parkLabel": "Park Label",
    "agency": "Agency",
    "amountToImprint": "Amount to Imprint in EuroCents",
    "installationDate": "Installation Date",
    "advenirBootstrap": "Advenir Bootstrap",
    "testTransactionId": "Test Transaction ID",
    "sendTestData": "Send Test Data",
    "installed": "Installed",
    "test": "Test",
    "gireve": "Gireve",
    "coupon": "Coupon",
    "pilotage": "Pilotage",
    "roof": "Solar",
    "featureOnlySolar": "Fixed Power Override Feature",
    "contractNoInfo": "No Contract",
    "contractTiltDisabled": "TILT off",
    "tilt": "TILT",
    "note": "Note",
    "save": "Save",
    "errorAdvenirTestData": "Error during Advenir Test Data send",
    "prm_error": "PRM must be exactly 14 digits",
    "parkNameAsciiError": "Park name must contain only ASCII characters",
    "prmEmptyError": "You cannot submit a park as installed if the PRM field is empty.",
    "yearlyReportImageMissingError": "You cannot submit a park as installed without a yearly_report_image registered.",
    "maintenanceDataMissingError": "You cannot submit a park as installed without Maintenance Data registered."
  },
  "it": {
    "generals": "Generali",
    "parkName": "Nome del Parco",
    "parkLabel": "Nome Pubblico Parco",
    "agency": "Agenzia",
    "amountToImprint": "Importo da Imprimere in Centesimi di Euro",
    "installationDate": "Data di Installazione",
    "advenirBootstrap": "Bootstrap Advenir",
    "testTransactionId": "ID Transazione di Test",
    "sendTestData": "Invia Dati di Test",
    "installed": "Installato",
    "test": "Test",
    "gireve": "Gireve",
    "coupon": "Coupon",
    "pilotage": "Pilotaggio",
    "roof": "Solare",
    "featureOnlySolar": "Override Potenza Fissa",
    "contractNoInfo": "Nessun contratto",
    "contractTiltDisabled": "TILT off",
    "tilt": "TILT",
    "note": "Nota",
    "save": "Salva",
    "errorAdvenirTestData": "Errore durante l'invio dei dati di test Advenir",
    "prm_error": "Il codice PRM deve essere di 14 cifre",
    "parkNameAsciiError": "Il nome del parco può contenere solo caratteri ASCII",
    "prmEmptyError": "Non puoi salvare un parco come installato se il campo PRM è vuoto.",
    "yearlyReportImageMissingError": "Non puoi salvare un parco come installato senza yearly_report_image registrato.",
    "maintenanceDataMissingError": "Non puoi salvare un parco come installato senza Dati di Manutenzione registrati."
  },
  "fr": {
    "generals": "Généraux",
    "parkName": "Nom du Parc",
    "parkLabel": "Nom Public du Parc",
    "agency": "Agence",
    "amountToImprint": "Montant à Imprimer en Centimes d'Euro",
    "installationDate": "Date d'Installation",
    "advenirBootstrap": "Bootstrap Advenir",
    "testTransactionId": "ID de Transaction de Test",
    "sendTestData": "Envoyer les Données de Test",
    "installed": "Installé",
    "test": "Test",
    "gireve": "Gireve",
    "coupon": "Coupon",
    "pilotage": "Pilotage",
    "roof": "Solaire",
    "featureOnlySolar": "Surcharge Puissance Fixe",
    "contractNoInfo": "Pas de contrat",
    "contractTiltDisabled": "TILT off",
    "tilt": "TILT",
    "note": "Note",
    "save": "Enregistrer",
    "errorAdvenirTestData": "Erreur lors de l'envoi des données de test Advenir",
    "prm_error": "Le PRM doit contenir exactement 14 chiffres",
    "parkNameAsciiError": "Le nom du parc ne peut contenir que des caractères ASCII",
    "prmEmptyError": "Vous ne pouvez pas soumettre un parc comme installé si le champ PRM est vide.",
    "yearlyReportImageMissingError": "Vous ne pouvez pas soumettre un parc comme installé sans yearly_report_image enregistré.",
    "maintenanceDataMissingError": "Vous ne pouvez pas soumettre un parc comme installé sans Données de Maintenance enregistrées."
  }
}
</i18n>

<style scoped>
.checkbox-item {
  border: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: 4px;
  padding: 0 8px;
  margin: 2px 0;
}
</style>
